import React, { useState } from 'react';
import { Flex, FlexBehavior } from 'react-magma-dom';

import { RouteComponentProps, useNavigate } from '@reach/router';
import { StyledContainer, StyledFlexLeftSide, StyledPageContainer } from '../../components/Styled/StyledLogin';
import { StyledFlexAddCode } from '../../components/Styled/StyledAddCode';
import { LeftSide } from '../Login/LeftSide';
import { AddCode } from './AddCode';
import { CrossButton } from '../../components/Button';
import { TermsOfUseModal } from '../../components/Modal';

export const AccessCode: React.FC<RouteComponentProps> = (): JSX.Element => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const navigate = useNavigate();

  const handleCrossClick = () => {
    navigate(-1);
  };

  return (
    <StyledPageContainer data-testid="access-code">
      <StyledContainer>
        <Flex behavior={FlexBehavior.container} spacing={0}>
          <CrossButton ariaLabel="exit" onClick={handleCrossClick} visible={true} top={40} right={40} />
          <StyledFlexLeftSide behavior={FlexBehavior.item}>
            <LeftSide />
          </StyledFlexLeftSide>
          <StyledFlexAddCode behavior={FlexBehavior.item}>
            <AddCode setIsTermsOfUseModalOpened={setIsModalOpened} />
          </StyledFlexAddCode>
        </Flex>
      </StyledContainer>
      {isModalOpened && (
        <TermsOfUseModal
          onClose={() => {
            setIsModalOpened(false);
          }}
        />
      )}
    </StyledPageContainer>
  );
};
